import styled, { css } from "styled-components";

export const InfoPopoverContent = styled.div(() => {
    return css`
        padding: 0.5rem 1rem;
        max-width: 250px;
        strong {
            font-weight: 700 !important;
        }

        br {
            display: block;
            margin-bottom: 0.4em;
            content: "";
        }
    `;
});
